import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { UploadResultType } from 'src/app/enums/upload-result-type.enum';
import { ErrorDetailsDialogResult } from 'src/app/models/dialog/error-details-dialog-result.model';
import { ErrorDialogData } from 'src/app/models/dialog/error-dialog.model';
import { Employee } from 'src/app/models/employee.model';
import { UploadResultItem } from 'src/app/models/other/upload-result-item.model';
import { ErrorMessageService } from 'src/app/shared/services';

@Component({
  selector: 'app-error-details-dialog',
  templateUrl: './error-details-dialog.component.html',
  styleUrls: ['./error-details-dialog.component.scss']
})
export class ErrorDetailsDialogComponent implements OnInit {

  public title: string;  
  public resultItems: UploadResultItem[] = [];

  public errorKeys: string[];
  public warningKeys: string[];
  public fieldErrorKeys: string[];

  public dialogResult: ErrorDetailsDialogResult;

  constructor(
    public dialogRef: MatDialogRef<ErrorDetailsDialogComponent>,
    public msgService: ErrorMessageService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData
  ) { }

  public get hasError(): boolean {
    return this.data.errorData != null || this.errorKeys?.length > 0;
  }

  public get hasWarning(): boolean {
    return this.warningKeys?.length > 0;
  }

  ngOnInit(): void {
    this.title = this.data.title;
        
    if (this.data.employeeErrorList == null && this.data.employeeWarningList == null)
    {
      this.data.errorData = {key: 'unknownError', msg: ''};
      return;
    }

    this.errorKeys = Object.keys(this.data.employeeErrorList);

    this.translate.stream([
      'ERROR_DETAILS_DIALOG.ERRORS_TITLE',
      'ERROR_DETAILS_DIALOG.ERRORS_SUBTITLE',
      'ERROR_DETAILS_DIALOG.NOTES_TITLE',
      'ERROR_DETAILS_DIALOG.NOTES_SUBTITLE',
      'ERROR_DETAILS_DIALOG.EXCEL_ERRORS_TITLE',
      'ERROR_DETAILS_DIALOG.EXCEL_ERRORS_SUBTITLE'
    ]).subscribe(translations => {
      if (this.errorKeys.length > 0)
      {
        this.resultItems.push({
          title: translations['ERROR_DETAILS_DIALOG.ERRORS_TITLE'],
          subtitle: translations['ERROR_DETAILS_DIALOG.ERRORS_SUBTITLE'],
          keys: this.errorKeys,
          items: this.data.employeeErrorList,
          isError: true
        });
      }

      this.warningKeys = Object.keys(this.data.employeeWarningList);
      if (this.warningKeys.length > 0)
      {
        this.resultItems.push({
          title: translations['ERROR_DETAILS_DIALOG.NOTES_TITLE'],
          subtitle: translations['ERROR_DETAILS_DIALOG.NOTES_SUBTITLE'],
          keys: this.warningKeys,
          items: this.data.employeeWarningList,
          isError: false
        });
      }

      if (this.data.importFieldErrors) {
        this.fieldErrorKeys = Object.keys(this.data.importFieldErrors);
        if (this.fieldErrorKeys.length > 0)
        {
          this.resultItems.push({
            title: translations['ERROR_DETAILS_DIALOG.EXCEL_ERRORS_TITLE'],
            subtitle: translations['ERROR_DETAILS_DIALOG.EXCEL_ERRORS_SUBTITLE'],
            keys: this.fieldErrorKeys,
            items: this.data.importFieldErrors,
            isError: true
          });
        }
      }
    });
    
  }

  public isEmployee(item: any): boolean {
    return !!item.name || !!item.email;
  }

  public showMainMessage() {
    const error = this.data.errorData;
    let message = '';

    if (error)
    {
      if (error?.key)
      {
        const msg = this.msgService.getErrorMessage(error.key);
        message = this.translate.instant(msg.translationKey);
      }
      else if (error?.msg)
      {
          message = error.msg;
      }
    }
    else
    {
      if (this.errorKeys?.length > 0 || this.warningKeys?.length > 0)
      {      
        const msg = this.msgService.getErrorMessage(this.data.defaultErrorKey);
        message = this.translate.instant(msg.translationKey);
      }
    }

    return message;
  }

  public getDetailMessage(key: string): string {
    const msg = this.msgService.getErrorMessage(key);
    return this.translate.instant(msg.translationKey);
  }

  public showDetail(data: any)
  {
    return '';
  }
  
  public continue() {
    this.dialogResult = { dialogCloseResult: 'continue' };
    this.dialogRef.close(this.dialogResult);
  }

  public close() {
    this.dialogResult = { dialogCloseResult: 'close' };

    if (this.hasError)
      this.dialogResult.uploadResultType = UploadResultType.Error;
    else if (this.hasWarning)
      this.dialogResult.uploadResultType = UploadResultType.Interrupted;

    this.dialogRef.close(this.dialogResult);
  }

  public isItemNumber(item: any): boolean {
    return typeof item === 'number';
  }
  
}
